<template>
    <tariff :tariffs="tariffs" :objectTariffs="objectTariffs" :profile-tariff="profileTariff" :is-fetched="tariffsIsFetched" />
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Tariff from './Tariff';

    export default {
        name: 'tariff-container',
        components: {
            Tariff,
        },
        data() {
            return {
                isFetching: false,
            }
        },
        methods: {
            ...mapActions('tariff', ['fetchTariffs']),
            ...mapActions('profileTariff', ['fetchProfileTariff']),
        },
        created() {
            if (!this.tariffsIsFetched) {
                this.isFetching = true;
                this.fetchTariffs()
                    .then((res) => {
                        this.isFetching = false;
                    })
                    .catch((res) => {
                        this.isFetching = false;
                    });
            }

            this.fetchProfileTariff().catch((res) => res);
        },
        computed: {
            ...mapState('tariff', ['tariffs']),
            ...mapGetters('tariff', {
                tariffsIsFetched: 'isFetched',
                objectTariffs: 'objectTariffs',
            }),
            ...mapGetters('profileTariff', {
                profileTariff: 'profileTariffId',
                profileTariffIsFetched: 'isFetched',
            }),
        }
    }
</script>



// WEBPACK FOOTER //
// TariffContainer.vue?ce7f431a